import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('cpSet');

const cpSet = async (val) => {
  try {
    const text = fromAnyToString(val);

    await navigator.clipboard.writeText(text);

    return text;
  } catch (e) {
    L.warn('cpSet()', e);
    return '';
  }
};

// noinspection JSUnusedGlobalSymbols
export default cpSet;
